export default __webpack_public_path__ + "static/media/Bifana-2.cffc30c8.jpg";